import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiCheck, HiOutlineSparkles } from 'react-icons/hi';
import './BuyCredits.css';

// PHASE 1: Credit purchasing disabled
// All messaging and features are completely free during Phase 1
// Credits will be re-enabled in Phase 2

const BuyCredits = () => {
  const navigate = useNavigate();

  return (
    <div className="buy-credits-container">
      <div className="credits-message-card">
        <div className="phase-badge">Phase 1 - Free</div>
        
        <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <HiOutlineSparkles aria-hidden="true" /> Good News!
        </h1>
        
        <p className="main-message">
          All messaging and features are completely <strong>FREE</strong> in Phase 1!
        </p>
        
        <p className="subtitle">
          You can send unlimited messages, browse profiles, and enjoy all features without purchasing credits.
        </p>
        
        <div className="features-list">
          {['Unlimited Messaging', 'Free Profile Browsing', 'Free Photo Viewing', 'Free Likes & Matches'].map((feature) => (
            <div key={feature} className="feature-item" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <HiCheck aria-hidden="true" style={{ color: '#22c55e', flexShrink: 0 }} /> {feature}
            </div>
          ))}
        </div>
        
        <p className="coming-soon">
          Premium features will be available in Phase 2. Stay tuned!
        </p>
        
        <button 
          onClick={() => navigate('/discover')}
          className="btn-return-primary"
        >
          Start Connecting →
        </button>
      </div>
    </div>
  );
};

export default BuyCredits;
